import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Button from 'components/common/Button';

const ButtonContainer = styled.div`
  display: inline-block;
`;

const CustomButton = styled(Button)`
  margin-top: 3rem;
  margin-bottom: ${props => `${props.extraMargin}rem`};
`;

SubmitButton.propTypes = {
  isActive: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  extraMargin: PropTypes.number
};

SubmitButton.defaultProps = {
  extraMargin: 15
};

function SubmitButton({isActive, title, onSubmit, extraMargin}) {
  return (
    <ButtonContainer>
      <CustomButton type="submit" width={22.3} isActive={isActive} extraMargin={extraMargin} onClick={onSubmit}>
        {title}
      </CustomButton>
    </ButtonContainer>
  );
}

export default SubmitButton;
